import React from 'react';
import {
  Label,
} from 'reactstrap';
import Services from './services';
import { DatePicker } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import _ from 'lodash';
import SelectField from '../../../components/Form/SelectField';
import RFForm from '../../../components/Form/RFForm';

const MusorFilters = props => {
  const {
    submit,
    filterButtonLoading,
    formFilterEloadas,
    formFilterHelyszin,
    formFilterArchive,
    handleDateInputChange,
    handleSelectInputChange,
  } = props;

  const loadHelyszinekOptions = (input, callback) => {
    Services.listHelyszinSelect((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( h => h.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!input && !formFilterHelyszin && options.length === 1) {
          handleSelectInputChange(options[0], 'formFilterHelyszin')
        }
      }
    });
  }

  const loadEloadasokOptions = (input, callback) => {
    Services.listEloadasok(null, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( e => e.cim.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const renderForm = () => {

    let cardStyle = {
      padding: 10,
      margin: 'auto',
      width: '80%' 
    };

    return (
      <RFForm onSubmit={submit}>
        <div className="card">
          <div className="row" style={cardStyle}>
            <div className="col-md-3" style={{paddingRight: '2px'}}>
                <SelectField
                  label='Előadás:'
                  variant='async'
                  name="formFilterEloadas"
                  id="formFilterEloadas"
                  placeholder="Kezdj el gépelni..."
                  noOptionsMessage={() => 'Nincs keresési eredmény'}
                  onChange={v => handleSelectInputChange(v, 'formFilterEloadas')}
                  loadOptions={_.debounce(loadEloadasokOptions, 1000)}
                  getOptionLabel={option => option.cim}
                  getOptionValue={option => option.id}
                  value={formFilterEloadas}
                  isSearchable
                  isClearable
                  defaultOptions
                />
            </div>
            <div className="col-md-3" style={{paddingRight: '2px'}}>
                <SelectField
                  variant='async'
                  label='Helyszín:'
                  name="formFilterHelyszin"
                  id="formFilterHelyszin"
                  placeholder="Kezdj el gépelni..."
                  noOptionsMessage={() => 'Nincs keresési eredmény'}
                  onChange={v => handleSelectInputChange(v, 'formFilterHelyszin')}
                  loadOptions={_.debounce(loadHelyszinekOptions, 1000)}
                  getOptionLabel={option => option.nev}
                  getOptionValue={option => option.id}
                  value={formFilterHelyszin}
                  isSearchable
                  isClearable
                  defaultOptions
                />
            </div>
            <div className="col-md-3">
              <DatePicker
                label="Esemény kezdete (-tól):"
                onChange={(e, v) => handleDateInputChange(e, v, 'formFilterArchive')}
                value={formFilterArchive && new Date(formFilterArchive)}
                id="formFilterArchive"
                name="formFilterArchive"
              />
            </div>
            <div className="col-md-2"  style={{ marginTop: '30px', width: "100%" }}>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={filterButtonLoading}
              >
                {'Keresés'}
              </ProgressButton>
            </div>
          </div>
        </div>
      </RFForm>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        {renderForm()}
      </div>
    </div>
  );
}

export default MusorFilters;
